import Muuri from 'muuri';
import { debounce } from 'lodash-es';
import imagesLoaded from 'imagesloaded';
import webAnimations from 'web-animations-js';

function registerEvents() {

  const instance = new Muuri('.b-mosaic-list', {
    layoutOnResize: 200,
    layoutDuration: 400,
  });

  const refreshInstance = () => {
    instance.refreshItems().layout();
    document.body.classList.add('images-loaded');
  };

  window.addEventListener('load', () => {
    refreshInstance();
    window.addEventListener('resize', debounce(refreshInstance, 200));
  });
}

function init() {

  const rootElements = document.querySelectorAll('.b-mosaic-list') || [];

  if (rootElements.length > 0) {
    registerEvents();
  }
}

export default {
  init,
};
